module.exports = __webpack_public_path__ + "media/images/stop_hand-5709fa282294d3308a9448cfad89ccb4.svg";